import { ArrowUpRight } from "lucide-react";
import useReveal from "@/hooks/useReveal";
import { work } from "@/lib/home-content";

function Card({ item, i }) {
    const { ref, visible } = useReveal({ threshold: 0.12 });
    const filled = Boolean(item.name);
    const n = String(i + 1).padStart(2, "0");

    const inner = (
        <>
            <div className="relative aspect-[16/10] overflow-hidden bg-[#eef0f8]">
                {item.image ? (
                    <img src={item.image} alt={item.name} className="h-full w-full object-cover" />
                ) : (
                    <div className="flex h-full flex-col items-center justify-center gap-1 text-[#b4b8c7]">
                        <span className="font-display text-3xl font-extrabold tracking-tight">{n}</span>
                        <span className="text-[11px] font-medium uppercase tracking-[0.16em]">Add screenshot</span>
                    </div>
                )}
                <span className="absolute left-3 top-3 rounded-full bg-white/90 px-2.5 py-1 text-[10px] font-semibold uppercase tracking-wide text-[#5b5b66] ring-1 ring-black/5">
                    {filled ? item.category || "Website" : "Slot"}
                </span>
            </div>
            <div className="flex items-start justify-between gap-3 p-4">
                <div>
                    <h3 className="font-display text-base font-bold text-[#0a0a0b]">
                        {filled ? item.name : "Client website"}
                    </h3>
                    <p className="mt-0.5 text-sm text-[#6b6b75]">
                        {filled ? item.industry : "Name, industry, and URL go here"}
                    </p>
                </div>
                {filled && item.url ? (
                    <ArrowUpRight className="mt-0.5 h-4 w-4 shrink-0 text-[var(--brand)]" />
                ) : null}
            </div>
        </>
    );

    const cls = `reveal overflow-hidden rounded-3xl bg-white ring-1 ring-black/5 transition-all duration-300 ${
        visible ? "is-visible" : ""
    } ${filled ? "hover:-translate-y-1 hover:shadow-[0_18px_44px_rgba(43,80,255,0.14)]" : ""}`;

    if (filled && item.url) {
        return (
            <a
                ref={ref}
                href={item.url}
                target="_blank"
                rel="noreferrer"
                style={{ transitionDelay: `${(i % 3) * 70}ms` }}
                className={`${cls} block`}
            >
                {inner}
            </a>
        );
    }

    return (
        <div ref={ref} style={{ transitionDelay: `${(i % 3) * 70}ms` }} className={cls}>
            {inner}
        </div>
    );
}

export default function Work() {
    const { ref, visible } = useReveal();

    return (
        <section id="work" data-testid="work-section" className="bg-[#f6f7fb] px-5 py-14 sm:py-20">
            <div className="mx-auto max-w-5xl">
                <div ref={ref} className={`reveal mb-9 ${visible ? "is-visible" : ""}`}>
                    <span className="rounded-full bg-white px-3 py-1 text-xs font-semibold uppercase tracking-wide text-[var(--brand)] ring-1 ring-black/5">
                        {work.kicker}
                    </span>
                    <h2 className="mt-4 font-display text-3xl font-extrabold leading-tight text-[#0a0a0b] sm:text-4xl">
                        {work.title}
                    </h2>
                    <p className="mt-3 max-w-xl text-[15px] leading-relaxed text-[#5b5b66]">{work.subtitle}</p>
                </div>
                <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
                    {work.items.map((item, i) => (
                        <Card key={item.id} item={item} i={i} />
                    ))}
                </div>
            </div>
        </section>
    );
}
